import { combineReducers } from "redux";
import { authReducer } from "./auth";
import { dashboard } from "./dashboard";
import { investor } from "./investors";
import { transactions } from "./transactions";
import { profileReducer } from "./profile";
import { transactionHistory } from "./history";
import { support } from "./support";
import { loading } from "./loader";
import { newinvestor } from "./newinvestor";

const rootReducer = combineReducers({
  authReducer,
  dashboard,
  investor,
  transactions,
  profileReducer,
  transactionHistory,
  support,
  loading,
  newinvestor,
});

export default rootReducer;
